import { render, staticRenderFns } from "./BasicQueryNew.vue?vue&type=template&id=1430b394&scoped=true&"
import script from "./BasicQueryNew.vue?vue&type=script&lang=js&"
export * from "./BasicQueryNew.vue?vue&type=script&lang=js&"
import style0 from "./BasicQueryNew.vue?vue&type=style&index=0&id=1430b394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1430b394",
  null
  
)

export default component.exports